import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
import Spinner from "../../Components/UI/Spinner/Spinner";
import EditOptions from "../LandingPage/PostOption/PostOption";
import EditService from "../Services/ServicesOptions/ServicesOptions";
import EditAccessories from "../Accessories/AccessoriesOption/AccessoriesOption";
import EditRntal from "../Rentals/RentalOption/RentalOption";
import EditApparels from "../Apparels/ApparelsOptions/ApparelsOptions";
import Modal from "../../Components/UI/Modal/Modal";

class EditPost extends Component {
  state = {
    // ################### ERROR MODAL:
    showErrorModal: false,
    formErrorMessage: null,
  };

  vehicleTypeFormater = (type) => {
    switch (type) {
      case "car":
        return (type = "cars");
      case "motor":
        return (type = "motors");
      case "commercial":
        return (type = "commercials");
      case "car_service":
        return (type = "car_services");
      case "motor_service":
        return (type = "motor_services");
      case "commercial_service":
        return (type = "commercial_services");
      case "car_rental":
        return (type = "car_rentals");
      case "motor_rental":
        return (type = "motor_rentals");
      case "commercial_rental":
        return (type = "commercial_rentals");
      default:
        return type;
    }
  };

  errorModalHandler = (errMess) => {
    this.setState((prevState) => {
      return {
        showErrorModal: !prevState.showErrorModal,
        formErrorMessage: errMess,
      };
    });
  };

  render() {
    let vType = null,
      service = false,
      accessory = false,
      rental = false,
      apparels = null,
      editComponent = null;
    if (this.props.postToEdit) {
      vType = this.vehicleTypeFormater(this.props.postToEdit.data.vehicle_type);
      service = [
        "car_services",
        "motor_services",
        "commercial_services",
        "car_service",
        "motor_service",
        "commercial_service",
      ].includes(vType);
      accessory = [
        "car_parts_accessory",
        "motor_parts_accessory",
        "commercial_parts_accessory",
        "cars_parts_accessory",
        "motors_parts_accessory",
        "commercials_parts_accessory",
      ].includes(vType);
      rental = this.props.postToEdit.data.vehicle_type.includes("rental");
      apparels =
        this.props.postToEdit.data.vehicle_type === "all_apparels_merchandise";
      if (service) {
        editComponent = (
          <EditService
            postToEdit={this.props.postToEdit.data}
            vihecleType={vType}
            errorModalHandler={this.errorModalHandler}
            history={this.props.history}
            postMode={this.props.location.state}
          />
        );
      } else if (accessory) {
        editComponent = (
          <EditAccessories
            postToEdit={this.props.postToEdit.data}
            vihecleType={vType}
            errorModalHandler={this.errorModalHandler}
            history={this.props.history}
            postMode={this.props.location.state}
          />
        );
      } else if (rental) {
        editComponent = (
          <EditRntal
            postToEdit={this.props.postToEdit.data}
            vihecleType={vType}
            errorModalHandler={this.errorModalHandler}
            history={this.props.history}
            postMode={this.props.location.state}
          />
        );
      } else if (apparels) {
        editComponent = (
          <EditApparels
            postToEdit={this.props.postToEdit.data}
            errorModalHandler={this.errorModalHandler}
            history={this.props.history}
            postMode={this.props.location.state}
          />
        );
      } else {
        editComponent = (
          <EditOptions
            postToEdit={this.props.postToEdit.data}
            vihecleType={vType}
            errorModalHandler={this.errorModalHandler}
            history={this.props.history}
            postMode={this.props.location.state}
          />
        );
      }
    }
    return (
      <Fragment>
        <Modal
          showModal={this.state.showErrorModal}
          closeModal={this.errorModalHandler}
        >
          <div>
            <h4 style={{ color: "red", textAlign: "center" }}>Invalid </h4>
            <p style={{ whiteSpace: "pre-wrap" }}>
              {this.state.formErrorMessage}
            </p>
          </div>
        </Modal>
        {this.props.loadinGetEditPost === true ? (
          <div style={{ width: "300px", margin: "0 auto" }}>
            <Spinner />
          </div>
        ) : this.props.postToEdit ? (
          editComponent
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loadinGetEditPost: state.EditPost.loadinGetEditPost,
    postToEdit: state.EditPost.postToEdit,
    error: state.EditPost.errort,
  };
};

// const mapDispatchToProps = dispatch => {
//     return {

//     }
// };

export default connect(mapStateToProps)(EditPost);
